"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function MaliciousfilescanBrownMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 17",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M7.5 12c2.485 0 4.5-1.928 4.5-4.305 0-2.378-2.015-4.306-4.5-4.306S3 5.317 3 7.695C3 10.072 5.015 12 7.5 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M10.639 10.706c1.404-1.329 1.761-3.787.622-4.99-1.139-1.203.463 1.752-1.95 3.734-2.081 2.016-5.137.581-3.998 1.785 1.14 1.203 3.922.8 5.326-.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M7.493 3.9a3.751 3.751 0 013.746 3.746 3.751 3.751 0 01-3.746 3.747 3.751 3.751 0 01-3.746-3.747A3.751 3.751 0 017.493 3.9zm0-.808a4.554 4.554 0 100 9.108 4.554 4.554 0 000-9.108z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M12.5 13.058a.414.414 0 01-.287-.117l-2.032-2.033a.403.403 0 11.57-.57l2.032 2.033a.402.402 0 01-.287.687h.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.856 7.153a.525.525 0 00-.691.267.525.525 0 00.477.736.528.528 0 00.48-.312.517.517 0 00-.266-.687v-.004zM7.768 7.153a.525.525 0 00-.691.267.525.525 0 00.477.736.528.528 0 00.48-.312.517.517 0 00-.266-.687v-.004zM9.683 7.153a.525.525 0 00-.691.267.525.525 0 00.477.736.528.528 0 00.48-.312.517.517 0 00-.266-.687v-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M5.92 14.008c-2.218-.586-4.037-2.264-4.72-4.466-.683-2.203-.178-4.632 1.334-6.353A6.616 6.616 0 018.39.954c2.194.27 4.15 1.69 5.137 3.673 1.277 2.567.675 5.695-1.338 7.7-.416.412.226 1.054.643.642 2.02-2.013 2.808-5.04 1.907-7.764C13.951 2.83 12 .95 9.582.275 7.165-.4 4.402.23 2.49 1.944S-.311 6.293.1 8.826c.477 2.926 2.736 5.307 5.581 6.059.566.15.809-.728.243-.877H5.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M8.382 15.026l-1.972-1.94a.136.136 0 00-.23.065l-.696 2.68a.138.138 0 00.17.169l2.667-.736c.101-.028.138-.157.06-.23v-.008z"
  }));
}

MaliciousfilescanBrownMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
MaliciousfilescanBrownMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = MaliciousfilescanBrownMultitoneFilled;
exports["default"] = _default;